import { makeAutoObservable } from 'mobx';
import { PersonalAssetHistoryMetaDataDto } from '../../../../defs/api';
import { SavingsAccountHistoryMetaDataMobxDto } from './savings-account-history-meta-data-mobx-dto';

export class PersonalAssetHistoryMetaDataMobxDto implements PersonalAssetHistoryMetaDataDto {
    savingsAccount?: SavingsAccountHistoryMetaDataMobxDto;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: PersonalAssetHistoryMetaDataDto): PersonalAssetHistoryMetaDataMobxDto {
        const mobxDto = new PersonalAssetHistoryMetaDataMobxDto();
        return Object.assign(mobxDto, dto, {
            savingsAccount: dto.savingsAccount
                ? SavingsAccountHistoryMetaDataMobxDto.create(dto.savingsAccount)
                : undefined,
        });
    }

    static createFromArray(dtos: PersonalAssetHistoryMetaDataDto[]): PersonalAssetHistoryMetaDataMobxDto[] {
        const createdDtos: PersonalAssetHistoryMetaDataMobxDto[] = [];
        dtos.forEach((dto) => {
            createdDtos.push(PersonalAssetHistoryMetaDataMobxDto.create(dto));
        });

        return createdDtos;
    }
}
